import React from 'react'
import PropTypes from 'prop-types'
import cssModules from 'react-css-modules'
import styles from './send_note.less'
import TextBox from 'components/common/text_box'
import { getI18n } from 'client/i18n'
import { SEND_NOTE_ROWS } from 'shared/lengths'
import SubmitLink from 'components/common/submit_link'
import { glimpseRoute } from 'lib/route_utils'
import { POOLS_CAMPAIGN_TYPES } from 'shared/shared_consts'

const i18n = getI18n('components/send_glimpse/send_note')

const { CROWD_FUNDING } = POOLS_CAMPAIGN_TYPES

class SendGlimpse extends React.Component {
  static propTypes = {
    handleSubmit: PropTypes.func,
    fields: PropTypes.object,
    anyInactiveFieldsTouchedWithError: PropTypes.bool.isRequired,
    location: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    shouldAutoFocus: PropTypes.bool,
    isGuest: PropTypes.bool,
    currency: PropTypes.string,
    amount: PropTypes.string,
    campaignId: PropTypes.string.isRequired,
    campaignType: PropTypes.string,
    anonymous: PropTypes.bool,
  }

  /**
   * Redirect from this component in the guest flow to p2pnodeweb where
   * they'll finish their guest signup and transaction.
   */
  handleRedirect = () => {
    const {
      campaignId,
      currency,
      amount,
      anonymous,
      fields: { note = {} },
    } = this.props
    const e = window.encodeURIComponent
    const guestP2PPath = '/myaccount/transfer/guestLogin/pools/'
    const guestP2PParams = `?poolId=${campaignId}&amount=${amount}&currencyCode=${currency}&anon=${anonymous}&note=${e(
      note.value
    )}`
    window.location.href = `${guestP2PPath}${guestP2PParams}`
  }

  render() {
    const {
      fields: { note },
      handleSubmit,
      anyInactiveFieldsTouchedWithError,
      isGuest,
      campaignType,
    } = this.props
    const buttonClassNames = `vx_btn vx_btn-block ${
      anyInactiveFieldsTouchedWithError ? 'vx_btn-disabled' : ''
    }`
    const shouldDisableNextBtn = !!note.error
    const descriptionKey =
      campaignType === CROWD_FUNDING ? 'cf_description' : 'description'
    return (
      <form>
        <div styleName="title">{i18n('title')}</div>
        <div styleName="description">{i18n(descriptionKey)}</div>
        <div styleName="note-container">
          <TextBox
            {...note}
            alwaysShowErrors={true}
            multiline={true}
            title={i18n('textbox_title')}
            autoFocus={this.props.shouldAutoFocus}
            rows={SEND_NOTE_ROWS}
            dataNemo="commentBox"
          />
        </div>
        {isGuest ? (
          <button
            data-pa-click="continueToGuestP2P"
            type="button"
            className={buttonClassNames}
            onClick={handleSubmit(() => this.handleRedirect())}
            disabled={shouldDisableNextBtn}
          >
            {i18n('next')}
          </button>
        ) : (
          <SubmitLink
            handleSubmit={handleSubmit}
            to={glimpseRoute('send', 'review')}
            className={buttonClassNames}
            text={i18n('next')}
            dataNemo="next"
            disabled={shouldDisableNextBtn}
          />
        )}
      </form>
    )
  }
}

export default cssModules(SendGlimpse, styles)
